"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Matcher = void 0;
var Matcher;
(function (Matcher) {
    Matcher["Equal"] = "equal";
    Matcher["NotEqual"] = "not_equal";
    Matcher["In"] = "in";
    Matcher["NotIn"] = "not_in";
    Matcher["All"] = "all";
    Matcher["Contains"] = "contains";
    Matcher["NotContains"] = "not_contains";
    Matcher["GreaterThan"] = "greater_than";
    Matcher["LowerThan"] = "lower_than";
    Matcher["LowerThanEqual"] = "lower_than_equal";
    Matcher["GreaterThanEqual"] = "greater_than_equal";
    Matcher["ContainsWord"] = "contains_word";
    Matcher["IsNull"] = "is_null";
    Matcher["IsNotNull"] = "is_not_null";
})(Matcher = exports.Matcher || (exports.Matcher = {}));
